import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import LogsViewer from '../components/DevComponents/Logs';
import Panel from '../components/DevComponents/Panel';
import AddUser from '../components/DevComponents/AddUser';

export default function DevHome(props) {
  const { devMode, ...routeProps } = props;
  
  return (
    <Switch>
      <Route 
        exact 
        path="/dev" 
        render={routeProps => <Panel {...routeProps} devMode={devMode} />} 
      />
      <Route exact path="/dev/logs" component={LogsViewer} />
      <Route exact path="/dev/users" component={AddUser} />
      <Redirect from="/dev/*" to="/dev" />
    </Switch>
  );
}

